export const formulaTypes = {
    number: {
        code: 'number'
    },
    datetime: {
        code: 'datetime'
    },
    renewal: {
        code: 'renewal'
    }
}

export const dateTypes = {
    exact: {
        code: 1,
        label: 'exact'
    },
    now: {
        code: 2,
        label: 'now'
    }
}

export const periods = {
    years: {
        code: 'Y',
        label: 'years'
    },
    months: {
        code: 'M',
        label: 'months'
    },
    days: {
        code: 'D',
        label: 'days'
    },
    hours: {
        code: 'h',
        label: 'hours'
    },
    minutes: {
        code: 'm',
        label: 'minutes'
    },
    seconds: {
        code: 's',
        label: 'seconds'
    }
}
